export default {
  topFooter: {
    anyQuestions: 'Остались вопросы\nи предложения?',
    contactingADB: 'Обращение в АБД',
    titles: {
      parts: 'Разделы',
      projects: 'Проекты',
      methods: 'Способы покупки',
      catalog: 'Каталог',
    },
    links: {
      about: 'О компании',
      companyName: 'Ак Барс Дом',
      gardenHouses: 'Дома у сада',
      ishakiHouse: 'Дом на Исхаки',
      companyNamePartner: 'Ак Барс Дом Партнер',
      groupOfCompanies: 'Группа компаний «АБД»',
      getKeys: 'Получить ключи',
      edo: 'ЭДО',
      reminder: 'Памятка',
      referral: 'Реферальная программа',
      brightValleyPark: 'Парк «Светлая долина»',
      improvement: 'Благоустройство',
      stocks: 'Акции',
      news: 'Новости',
      estateMagazine: 'Журнал о недвижимости М²',
      article: 'Статьи',
      FAQ: 'Вопросы и ответы',
      documents: 'Документы',
      contacts: 'Контакты',
      flats: 'Квартиры',
      parkings: 'Парковки',
      storerooms: 'Кладовки',
      commercials: 'Коммерческая недвижимость',
      housingComplex: 'Жилые комплексы',
      sunCitySuper: 'Солнечный город Супер',
      nobelevskii: 'Нобелевский',
      myRhythm: 'Мой Ритм',
      lightValley: 'Светлая долина',
      kazanXXI: 'Казань XXI век',
      sunCity: 'Солнечный город',
      commercialEstate: 'Коммерческая недвижимость',
      buyFlatOnline: 'Электронная сделка',
      mortgage: 'Ипотека',
      tradeIn: 'Трейд-ин',
      meansOfBuying: 'Способы покупки',
      installment: 'Рассрочка',
      maternityCapital: 'Материнский капитал',
      certificatesAndGrants: 'Сертификат и субсидии',
      movingToKazan: 'Переезжаем в Казань',
    },
    salesDepartment: 'Отдел продаж',
    getRecall: 'Заказать обратный звонок',
    address: 'Адрес',
    addressContent: 'г. Казань, ул. Альберта Камалеева, 28/9',
    operatingModeSalesDepartment: {
      addressContent: '420081, г. Казань, ул. Альберта Камалеева, 26/12',
      title: 'Режим работы отдела продаж:',
      timeRange: 'Пн-Пт: с 09:00 до 20:00',
      dayOffTimeRange: 'Сб-Вс: с 10:00 до 16:00',
    },
    operatingModeOffice: {
      addressContent: '420025, г. Казань, ул. Сабира Ахтямова, д.1 корпус 1',
      title: 'Режим работы офиса:',
      timeRange: 'Пн-Пт: с 09:00 до 18:00',
      dayOffTimeRange: 'Сб: с 10:00 до 16:00',
      sunday: 'Вс: выходной',
    },
  },
  bottomFooter: {
    offerText:
      'Любая информация, представленная на данном сайте, носит исключительно информационный характер и ни при каких условиях не является публичной офертой, определяемой положениями статьи 437 Гражданского кодекса РФ. Компания "Ак Барс Дом" принимает на себя гражданско-правовые обязательства исключительно в результате отдельно и специально совершенных сделок.',
    copyright: '© 2020 «Ак Барс Дом»',
    privacyPolicy: 'Политика конфиденциальности',
  },
};
